
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-benefit",
      function () {
        return require("private-next-pages/gangwon-benefit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-benefit"])
      });
    }
  